import { Cell } from '../grid/Cell'
import strawberry from '../../strawberry.png'

type Props = {
  start: () => void
}

export const HowToPlay = ({ start }: Props) => {
  return (
    <div className="mx-auto max-w-xl p-4 text-center">
      <div className={"flex items-center justify-between mb-4"}>
        <img src={strawberry} className="w-6" alt="" />

        <h1 className="text-3xl light-pink-text font-bold">
          Play the Baby Shower Wordle!
        </h1>

        <img src={strawberry} className="w-6" alt="" />
      </div>

      <p className="dark:text-gray-300">
        Try to guess the word in six attempts. After each guess, the <strong>color</strong> of the tiles will change to show you how close your guess is to the hidden word. The game has two rounds. Begin when the host says go!
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="W"
          status="correct"
        />
        <Cell value="E" />
        <Cell value="A" />
        <Cell value="R" />
        <Cell value="Y" />
      </div>
      <p className="dark:text-gray-300">
        The letter W is in the word and in the correct spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="P" />
        <Cell value="I" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="L"
          status="present"
        />
        <Cell value="O" />
        <Cell value="T" />
      </div>
      <p className="dark:text-gray-300">
        The letter L is in the word but in the wrong spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="V" />
        <Cell value="A" />
        <Cell value="G" />
        <Cell isRevealing={true} isCompleted={true} value="U" status="absent" />
        <Cell value="E" />
      </div>
      <p className="dark:text-gray-300">
        The letter U is not in the word in any spot.
      </p>

      <button
        onClick={start}
        className="button text-white px-4 py-2 rounded shadow mt-8"
      >
        Start the Wordle!
      </button>
    </div>
  )
}
